
export default function ProductCategoriesSection() {
  const categories = [
    {
      id: 1,
      name: '普洱生茶',
      count: '12款',
      image: 'https://public.readdy.ai/ai/img_res/074bee98ac9d5fad248b52457fa874dc.jpg',
      description: '自然发酵，清香回甘'
    },
    {
      id: 2,
      name: '普洱熟茶',
      count: '18款',
      image: 'https://readdy.ai/api/search-image?query=Premium%20ripe%20pu-erh%20tea%20category%20display%2C%20dark%20brown%20fermented%20tea%20leaves%2C%20traditional%20Chinese%20tea%20cake%20with%20golden%20wrapper%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20sophisticated%20product%20photography%2C%20luxury%20tea%20presentation%2C%20rich%20texture&width=400&height=400&seq=category-ripe-puerh&orientation=squarish',
      description: '人工发酵，醇厚浓香'
    },
    {
      id: 3,
      name: '六堡茶',
      count: '8款',
      image: 'https://readdy.ai/api/search-image?query=Premium%20Liu%20Bao%20tea%20category%20display%2C%20traditional%20dark%20tea%20with%20unique%20packaging%2C%20Chinese%20heritage%20tea%20culture%2C%20elegant%20presentation%2C%20clean%20white%20background%2C%20sophisticated%20product%20photography%2C%20artisanal%20tea%20craftsmanship%2C%20luxury%20styling&width=400&height=400&seq=category-liubao&orientation=squarish',
      description: '广西特产，槟榔香韵'
    },
    {
      id: 4,
      name: '珍藏系列',
      count: '6款',
      image: 'https://readdy.ai/api/search-image?query=Premium%20vintage%20aged%20tea%20collection%20display%2C%20luxury%20wooden%20tea%20box%20with%20golden%20accents%2C%20rare%20collectible%20Chinese%20tea%2C%20sophisticated%20presentation%2C%20clean%20white%20background%2C%20high-end%20product%20photography%2C%20exclusive%20tea%20treasures%2C%20elegant%20styling&width=400&height=400&seq=category-vintage&orientation=squarish',
      description: '稀有年份，珍贵典藏'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="mx-auto px-6 lg:px-[15%]">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#663333] mb-4">
            产品分类
          </h2>
          <p className="text-sm sm:text-lg text-gray-600">
            多元化产品线，满足不同茶友需求
          </p>
          <div className="w-24 h-1 bg-[#cc9966] mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8">
          {categories.map((category) => (
            <div
              key={category.id}
              className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 overflow-hidden cursor-pointer"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="p-4 lg:p-6 text-center">
                <h3 className="text-sm sm:text-base lg:text-lg font-bold text-[#663333] mb-2">
                  {category.name}
                </h3>
                <div className="bg-[#cc9966] text-white text-xs sm:text-sm px-2 lg:px-3 py-1 rounded-full inline-block mb-2 lg:mb-3">
                  {category.count}
                </div>
                <p className="text-xs sm:text-sm text-gray-600">
                  {category.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}